<template>
<div class="chapter">
<div class="inner_page">
<div id="d2-d5f88a5f148ed-d1e263"><span id="pagev">
<p class="prelims-epigraph ">Luna is a stern schoolmistress;</p>
<p class="prelims-epigraph ">those who have lived through her harsh lessons</p>
<p class="prelims-epigraph-space-after ">have no cause to feel ashamed.</p>
<p class="prelims-epigraph-source ">– Robert A. Heinlein, <em><em class="char-italic italic">The Moon is a Harsh Mistress</em></em></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781448303595_epub_epi.vue?0f97f8e1